<template>
     <app-layout>
        <template #header>
            <div class="relative flex justify-between items-center">
                <div>
                    <h2 class=" font-bold text-xl leading-tight">
                    <i class="fas fa-hand-holding-usd"></i>
                        Enviar
                    </h2>
                </div>
                <Balance :short="true"/>
            </div>
        </template>
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
            <div class="flex flex-wrap lg:flex-nowrap mx-4 xl:mx-32 lg:mx-20 md:mx-3 mt-6 md:mt-6 lg:mt-20">
                <div class="bg-white shadow-card px-5 py-4 rounded h-1/2 mr-0 lg:mr-10 w-full lg:w-2/5 mb-6 lg:mb-0">
                    <div class="max-w-7xl mx-auto">
                        <receipt
                            class="p-4 mt-0 w-full"
                            :logo="logo"
                            :extract="dataFake.extract"
                            :receipt="dataFake.receipt"
                        />
                    </div>
                </div>
                <div class="pt-6 pl-8 pr-6 pb-10 bg-white rounded shadow-card flex-1 self-start">
                    <div class="flex items-center justify-between mb-3">
                        <h3 class="font-medium">O que fazer agora?</h3>
                        <div class="flex items-center">
                            <RoundedIcon
                                class="w-9 h-9 bg-gray-900 text-white mr-4"
                                v-tippy
                                content="Compartilhar"
                                :icon="'fas fa-share-alt'"
                            />
                            <RoundedIcon
                                class="w-9 h-9 bg-green-500 text-white mr-4"
                                v-tippy
                                content="Baixar em PNG"
                                :icon="'far fa-file-image'"
                                @click.native="print('png')"
                            />
                            <RoundedIcon
                                class="w-9 h-9 bg-red-600 text-white"
                                v-tippy
                                content="Baixar em PDF"
                                :icon="'fas fa-file-pdf'"
                                @click.native="print('pdf')"
                            />
                        </div>
                    </div>
                    <a :href="route('send.index')">
                        <div class="flex items-center border-b px-4 py-4">
                            <RoundedIcon class="bg-yellow-400" :icon="'fas fa-paper-plane'" />
                            <div class="ml-3 flex-1">
                                <div class="text-sm leading-4">
                                    Realizar um novo envio
                                </div>
                            </div>
                            <i class="text-gray-400 fas fa-chevron-right p-2" />
                        </div>
                    </a>
                    <a href="/dashboard">
                        <div class="flex items-center border-b px-4 py-4">
                            <RoundedIcon class="bg-yellow-400" :icon="'fas fa-home'" />
                            <div class="ml-3 flex-1">
                                <div class="text-sm leading-4">
                                    Voltar para home
                                </div>
                            </div>
                            <i class="text-gray-400 fas fa-chevron-right p-2" />
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout.vue";
import RoundedIcon from './components/RoundedIcon.vue';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import Receipt from '../Receipt/Receipt.vue';
import Balance from "../../Helpers/Balance.vue";

export default {
    name: "SharedReceipt",
    props: ['receipt', 'extract', 'errors','logo'],
    components: {
        RoundedIcon,
        Receipt,
        AppLayout,
        Balance
    },
    computed: {
        dataFake(){
            return {
                extract: {
                    operation_code: '4156461347'
                },
                receipt:{
                    content: {
                        agenciaContaOrigem:{
                            contaNumero: '12635',
                            contaDigito: '6'
                        },
                        correntistaOrigem: {
                            documentoFederal: '52230859311'
                        },
                        tituloNome: 'GLA SERVIÇOS DE TECNOLOGIA LTDA',
                        tituloDocumentoFederal: '09605269000176',
                        vlrTransacao: '50,00',
                        bancoDestino: {
                            numero: '274',
                            descricao: 'Money Plus'
                        },
                        agenciaContaDestino: {
                            agenciaNumero: '00001',
                            agenciaDigito: '8',
                            contaNumero: '15349',
                            contaDigito: '4'
                        },
                        destinoTipoConta: '1',
                        DescOperacao: 'ds15d1s5',
                        dtTransacao: '2022-09-19T10:00:00',
                        transfCodigoAutenticacao: 'a834b3b2-3822-11ed-a261-0242ac120002'
                    }
                }
            }
        }
    },
    methods: {
        print(type) {
            html2canvas(document.querySelector('#transfer-receipt'), {dpi: 144, scale: 1}).then(canvas => {
                let imgData = canvas.toDataURL('image/png');
                if (type === 'png'){
                    const a = document.createElement('a');
                    a.href = imgData;
                    a.download = 'comprovante.png';
                    a.click();
                    return
                }
                let doc = new jsPDF();
                doc.addImage(imgData, 'PNG', 10, 10);
                doc.save(`comprovante.${type}`);
            });
        }
    }
}
</script>
